export default __webpack_public_path__ + "static/media/right-arrow.96d27d93.svg";